import { BaseActivityEvent } from './BaseActivityEvent'
import { ReactComponent as Icon } from './icons/approval.svg'
import { Actor } from './Actor'
import { ActivityEventPosition, ArticleReviewRejectionEvent } from './Types'

interface Props extends ActivityEventPosition {
  event: ArticleReviewRejectionEvent
}

const ArticleReviewRejection = ({ event, ...props }: Props) => {
  const { reviewer, requester, message } = event.data

  return (
    <BaseActivityEvent
      {...props}
      icon={<Icon />}
      timestamp={event.timestamp}
      message={message}
      content={
        <>
          <Actor displayName={reviewer.display_name || 'Anonymous User'} userId={reviewer?.id} /> sent back changes to{' '}
          <Actor displayName={requester.display_name || 'Anonymous User'} userId={requester?.id} />
        </>
      }
    />
  )
}

export { ArticleReviewRejection }
